/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UpdateAdditionalInsuredDto } from './UpdateAdditionalInsuredDto';
import type { UpdateAddressDto } from './UpdateAddressDto';
import type { UpdateMainContactDto } from './UpdateMainContactDto';
export type UpdateClientDto = {
    /**
     * Title (MR, MRS, MS, DOCTOR, etc. — uppercase Ando values)
     */
    title?: string;
    /**
     * First name (for INDIVIDUAL clients) or business name (for BUSINESS clients)
     */
    firstName?: string;
    /**
     * Last name (for INDIVIDUAL clients). For BUSINESS clients, this can be empty.
     */
    lastName?: string;
    /**
     * Date of birth (for INDIVIDUAL clients)
     */
    dob?: string;
    /**
     * Gender (for INDIVIDUAL clients)
     */
    gender?: UpdateClientDto.gender;
    /**
     * Type of client
     */
    clientType?: UpdateClientDto.clientType;
    /**
     * Client status
     */
    status?: UpdateClientDto.status;
    /**
     * Primary phone number
     */
    phone?: string;
    /**
     * Primary email address
     */
    email?: string;
    /**
     * When true, allows updating a client email even if another client of the same type already uses it. Requires explicit user confirmation in the UI.
     */
    allowDuplicateEmail?: boolean;
    /**
     * UUID of the assigned adviser
     */
    assignedAdviserId?: string;
    /**
     * Company registration number (for BUSINESS clients)
     */
    companyRegNo?: string;
    /**
     * Trading as name (for BUSINESS clients)
     */
    tradingAs?: string;
    /**
     * GST number (for BUSINESS clients)
     */
    gstNumber?: string;
    /**
     * Flag indicating if client is vulnerable
     */
    isVulnerable?: boolean;
    /**
     * Flag indicating if client has policies with other providers
     */
    hasMultiplePolicies?: boolean;
    /**
     * Unallocated cash held on account for this client
     */
    unallocatedCash?: number;
    /**
     * Additional notes about the client
     */
    notes?: string;
    /**
     * Main contact details (only for BUSINESS clients)
     */
    mainContact?: UpdateMainContactDto;
    /**
     * List of addresses for the client. Addresses with an id will be updated, and addresses without an id will be created. At least one correspondence address is required.
     */
    addresses?: Array<UpdateAddressDto>;
    /**
     * List of additional insured persons. Items with an id will be updated, items without an id will be created.
     */
    additionalInsureds?: Array<UpdateAdditionalInsuredDto>;
};
export namespace UpdateClientDto {
    /**
     * Gender (for INDIVIDUAL clients)
     */
    export enum gender {
        MALE = 'MALE',
        FEMALE = 'FEMALE',
        OTHER = 'OTHER',
    }
    /**
     * Type of client
     */
    export enum clientType {
        INDIVIDUAL = 'INDIVIDUAL',
        BUSINESS = 'BUSINESS',
    }
    /**
     * Client status
     */
    export enum status {
        IN_PROGRESS = 'IN_PROGRESS',
        BOUND = 'BOUND',
        LAPSED = 'LAPSED',
        RENEWAL_DUE = 'RENEWAL_DUE',
    }
}

